export const stationCodes = [
  'LBB',
  'FTM',
  'CPR',
  'HJN',
  'BLA',
  'BLM',
  'ASN',
  'SNY',
  'IST',
  'BNH',
  'STB',
  'DKA',
  'BHI'
];

export const baseFareMatrix = [
  [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 14],
  [4, 3, 4, 5, 6, 7, 7, 9, 9, 10, 11, 12, 13],
  [5, 4, 3, 3, 4, 5, 6, 7, 8, 9, 9, 10, 11],
  [6, 5, 3, 3, 3, 4, 5, 6, 7, 8, 8, 9, 10],
  [7, 6, 4, 3, 3, 3, 4, 5, 6, 7, 7, 8, 9],
  [8, 7, 5, 4, 3, 3, 3, 4, 5, 6, 6, 7, 8],
  [9, 7, 6, 5, 4, 3, 3, 3, 4, 5, 6, 7, 7],
  [10, 9, 7, 6, 5, 4, 3, 3, 3, 4, 4, 5, 6],
  [11, 9, 8, 7, 6, 5, 4, 3, 3, 3, 3, 4, 5],
  [12, 10, 9, 8, 7, 6, 5, 4, 3, 3, 3, 3, 4],
  [13, 11, 9, 8, 7, 6, 6, 4, 3, 3, 3, 3, 4],
  [14, 12, 10, 9, 8, 7, 7, 5, 4, 3, 3, 3, 3],
  [14, 13, 11, 10, 9, 8, 7, 6, 5, 4, 4, 3, 3]
];

export const buildFareState = () =>
  stationCodes.map((origin, rowIndex) =>
    stationCodes.map((destination, colIndex) => ({
      origin,
      destination,
      price: baseFareMatrix[rowIndex][colIndex] * 1000
    }))
  );
